import { useAdvisorCopy } from '@/shared/hooks/useAdvisorCopy';

/** UI-owned copy only; never wrap names, provider content or saved user text. */
export function AdvisorText({ source }: { source: string }) {
  const copy = useAdvisorCopy();
  return copy(source);
}
